export const isFullStatic = false
export const staticPath = "/home/runner/work/did-homepage/did-homepage/.nuxt/static-json"
export const publicPath = "https://das-data-assets.pages.dev/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"